import React from "react";
import Select from "react-select";
import Datepicker from "react-datepicker";
import Moment from "moment";
import Toaster from "toastr";
import FloatInput from "../../common/floatInput";
import { permissioned } from "../../common/permissionedHoc";
import Constants from "../../../configurations/constants";
import Util from "../../../util/util";
import Messages from "../../../configurations/messages";
import ErrorLabel from "../../common/errorLabel";
import ArbiterApi from "../../../api/ArbiterApi";
import SelectDropdown from "../disputes/DisputeSelectDropdown";

class NewClaimTxnFilter extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      txnType: null,
      identifier: "",
      fromDate: Moment()
        .subtract(Constants.MAX_DATE_RANGE_DAYS, "days")
        .startOf("day"),
      toDate: Moment().endOf("day"),
      stan: "",
      retrievalReferenceNumber: "",
      terminalId: "",
      toAccount: "",
      validity: {
        fromDate: true,
        toDate: true,
        dateRange: true,
        selectedChannel: false,
        txnType: false
      },
      filterValidity: {},
      validFilter: false,
      transactionGroups: [],
      currentTransactionGroup: null,
      transactionGroupFilters: [],
      transactionGroupFiltersRequired: [],
      transactionGroupFiltersAdditional: [],
      channels: [],
      selectedChannel: null,
      searchButtonDisabled: true,
      touchedForm: false
    };
    this.onTxnTypeChange = this.onTxnTypeChange.bind(this);
    this.onTextInputChange = this.onTextInputChange.bind(this);
    this.onFromDateChange = this.onFromDateChange.bind(this);
    this.onToDateChange = this.onToDateChange.bind(this);
    this.onSearchHandler = this.onSearchHandler.bind(this);
    this.generateFilterArrays = this.generateFilterArrays.bind(this);
    this.onChannelChange = this.onChannelChange.bind(this);
    this.createChannelFilter = this.createChannelFilter.bind(this);
  }

  // componentDidMount() {
  //   this.getTransactionGroups();
  // }

  getTransactionGroups = (cb) => {
    ArbiterApi.getTransactionGroups()
      .then(response => {
        let data = response.data;
        let groups = data || [];
        //Map groups to support the select field e.g add label and value properties
        groups = groups.map(item => {
          item.label = item.name;
          item.value = item.name;
          return item;
        });
        if(cb) cb();
        this.setState({ transactionGroups: groups });
      })
      .catch(error => {
        if(cb) cb();
        console.log(error);
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_TRANSACTION_GROUPS}`
        ]);
      });
  }

  componentDidUpdate(prevProps, prevState) {
    //Set Search button to be enabled (Initial State = 'disabled')
    if (
      this.state.searchButtonDisabled &&
      prevState.identifierType === this.state.identifierType
    )
      //Select txn type was not the control value  changed
      this.setState({ searchButtonDisabled: false });
  }

  createChannelFilter(filterArray, filterGroupSize) {
    let filters = [];
    if (filterArray) {
      let numberOfFilterGroups = Math.ceil(
        filterArray.length / filterGroupSize
      );
      for (let i = 0; i < numberOfFilterGroups; i++) {
        filters.push(
          filterArray.slice(filterGroupSize * i, filterGroupSize * (i + 1))
        );
      }
    }
    return filters;
  }

  generateFilterArrays(selectedChannel) {
    let filterGroupSize = 4;
    let transactionGroupFiltersRequired = [];
    let transactionGroupFiltersAdditional = [];

    if (selectedChannel) {
      if (selectedChannel.additionalParameters) {
        transactionGroupFiltersAdditional = this.createChannelFilter(
          selectedChannel.additionalParameters,
          filterGroupSize
        );
      }
      if (selectedChannel.requiredParameters) {
        transactionGroupFiltersRequired = this.createChannelFilter(
          selectedChannel.requiredParameters,
          filterGroupSize
        );
      }
    }

    return {
      transactionGroupFiltersRequired,
      transactionGroupFiltersAdditional
    };
  }

  onChannelChange(selectedChannel) {
    this.clearAdvancedInputs();
    const transactionGroupFilters = this.generateFilterArrays(selectedChannel);
    const transactionGroupFiltersRequired =
      transactionGroupFilters.transactionGroupFiltersRequired;
    const transactionGroupFiltersAdditional =
      transactionGroupFilters.transactionGroupFiltersAdditional;
    let validity = this.setValidityAndReturn(
      "selectedChannel",
      selectedChannel ? !!selectedChannel.value : false
    );

    this.setState(
      {
        transactionGroupFiltersRequired,
        transactionGroupFiltersAdditional,
        selectedChannel,
        filterValidity: {},
        validity
      },
      () => this.returnValidityFilters()
    );
  }

  onTextInputChange(event) {
    let value = event.target.value;
    let val =
      event.target.name === Constants.TXN_IDENTIFIER_PAN.name
        ? Util.maskPan(value)
        : value;
    let valid = this.validateInputField(event.target.name, val, false);
    let stateUpdate = {};
    stateUpdate[event.target.name] = val;
    stateUpdate.touchedForm = true;
    stateUpdate.filterValidity = this.setValidityAndReturn(
      event.target.name,
      valid,
      true
    );
    this.setState(stateUpdate, () => this.returnValidityFilters());
  }

  onFromDateChange(date) {
    //Set the 'toDate' to maximum date. Set validity for dates to 'true'
    let maxDate = date.clone();

    maxDate.add(Constants.MAX_DATE_RANGE_DAYS, "days").endOf("day");
    let validity = this.setValidityAndReturn("fromDate", true);
    validity.dateRange = true;
    validity.toDate = true;
    this.setState({
      fromDate: date.startOf("day"),
      toDate: maxDate,
      validity: validity,
      touchedForm: true
    });
  }

  onToDateChange(date) {
    let valid = date != null;
    let validDateRange = true;

    //Validate that from date isn't less than specified  month range
    if (this.state.fromDate) {
      let maxDate = date.clone();
      maxDate.subtract(Constants.MAX_DATE_RANGE_DAYS, "days").startOf("day");
      valid = date.unix() >= this.state.fromDate.unix();
      validDateRange = maxDate.unix() <= this.state.fromDate.unix();
    }
    let validity = this.setValidityAndReturn("toDate", valid);
    validity.dateRange = validDateRange;

    this.setState({
      toDate: date.endOf("day"),
      validity: validity,
      touchedForm: true
    });
  }

  onSearchHandler() {
    //TODO: validate control values
    //If  empty currentTransactionGroup
    if (!this.state.currentTransactionGroup) {
      let validityState = this.setValidityAndReturn(
        "currentTransactionGroup",
        !!this.state.currentTransactionGroup
      );
      this.setState({ validity: validityState });
      return;
    }

    //If  empty channel
    if (!this.state.selectedChannel) {
      let validityState = this.setValidityAndReturn(
        "selectedChannel",
        !!this.state.selectedChannel
      );
      this.setState({ validity: validityState });
      return;
    }

    //Build Params
    let params = {};
    let currentTransactionGroup = this.state.currentTransactionGroup;
    let selectedChannel = this.state.selectedChannel;

    //Additional Params
    if (selectedChannel.additionalParameters) {
      selectedChannel.additionalParameters.forEach(param => {
        let val = this.state[param];
        if (val) params[param] = val;
      });
    }

    //Required Params
    if (selectedChannel.requiredParameters) {
      selectedChannel.requiredParameters.forEach(param => {
        let val = this.state[param];
        if (val) params[param] = val;
      });
    }

    //Query Params
    // params[selectedChannel.customerReference] = this.state.identifier;

    //date params
    params.startDate = this.state.fromDate
      ? this.state.fromDate.format(Constants.DATE_FORMAT_LONG)
      : null;
    params.endDate = this.state.toDate
      ? this.state.toDate.endOf("day").format(Constants.DATE_FORMAT_LONG)
      : null;

    this.props.onSearchHandler &&
      this.props.onSearchHandler(
        currentTransactionGroup.name,
        selectedChannel.value,
        params
      );
  }

  onTxnTypeChange(event) {
    this.clearAdvancedInputs();

    //Map channels
    let channels =
      !event || !event.channels
        ? []
        : Object.keys(event.channels).map(c => {
            let channel = event.channels[c];
            channel.label = c;
            channel.value = c;
            return channel;
          });

    //Select first channel
    let selectedChannel =
      channels.length && channels.length === 1 ? channels[0] : null;

    let validityUpdate = {};
    validityUpdate["txnType"] = event ? !!event.value : false;
    selectedChannel
      ? (validityUpdate["selectedChannel"] = true)
      : (validityUpdate["selectedChannel"] = false);

    const transactionGroupFilters = this.generateFilterArrays(selectedChannel);
    const transactionGroupFiltersRequired =
      transactionGroupFilters.transactionGroupFiltersRequired;
    const transactionGroupFiltersAdditional =
      transactionGroupFilters.transactionGroupFiltersAdditional;

    const validity = {
      ...this.state.validity,
      ...validityUpdate
    };
    this.setState(
      {
        txnType: event ? event.name : "",
        currentTransactionGroup: event,
        transactionGroupFiltersRequired,
        transactionGroupFiltersAdditional,
        identifier: "",
        selectedChannel,
        channels: channels,
        category: null,
        validity,
        filterValidity: {},
        touchedForm: true
      },
      () => this.returnValidityFilters()
    );
  }

  render() {
    return (
      <form
        onSubmit={e => {
          this.onSearchHandler();
          e.preventDefault();
          return false;
        }}
      >
        <div>
          <div className="row" style={{ border: '2px solid #ff6347', padding: '10px', borderRadius: '10px',  marginLeft: '2px' }}>
            <div style={{ padding: '8px' }}>
              <p style={{ marginBottom: '15px' }}>Starting from March 1, 2024, The following transactions will be accessible for dispute resolution ONLY through the  <u><a href="https://idrs.nibss-plc.com.ng/login" target='_blank' style={{ color: '#23527c', fontWeight: 'bold' }}>NIBSS IDRS </a></u>   platform </p>
              
              <div className="row">
              <div  className="col-md-2" style={{ marginBottom: '7px',  marginLeft: '30px', }}>
                <ul style={{  marginBottom: '5px', listStyleType: 'disc'}}>
                  <li style={{  marginBottom: '5px'}}>ATM Cash withdrawal</li>
                  <li style={{  marginBottom: '5px'}}>POS Purchase</li>
                  <li style={{  marginBottom: '5px'}}>WEB Purchase</li>
                </ul>
              </div>
              </div>
            </div>
          </div>

          <br/>
          <br/>

          <div className="row">
            <div className="col-md-10">
              <div className="row filters">
                <div className="col-md-3">
                  <label className="input-control-label required">
                    Transaction group
                  </label>
                  {/* <Select
                    name="txnType"
                    placeholder="Tran. Group"
                    value={this.state.txnType}
                    options={this.state.transactionGroups}
                    onChange={this.onTxnTypeChange}
                  /> */}
                  <SelectDropdown
                    name="txnType"
                    placeholder="Tran. Group"
                    value={this.state.txnType}
                    options={this.state.transactionGroups}
                    onChange={this.onTxnTypeChange}
                    loadOptions={this.getTransactionGroups}
                  />
                  {this.state.touchedForm && !this.state.validity.txnType && (
                    <ErrorLabel message={Messages.INVALID_TXN_TYPE} />
                  )}
                </div>
                <div className="col-md-3">
                  <label className="input-control-label required">
                    Channel
                  </label>
                  <Select
                    name="channel"
                    placeholder="Channel"
                    value={this.state.selectedChannel}
                    options={this.state.channels}
                    onChange={this.onChannelChange}
                  />
                  {this.state.touchedForm && !this.state.validity.txnType && (
                    <ErrorLabel message={Messages.INVALID_CHANNEL} />
                  )}
                </div>

                <div className=" col-md-3">
                  <span className="datepicker-wrapper">
                    <label className="input-control-label required">From</label>
                    <Datepicker
                      onChange={this.onFromDateChange}
                      allowSameDay={true}
                      maxDate={Moment()}
                      className="form-control"
                      id="fromDate"
                      placeHolderText="From Date"
                      disabledKeyboardNavigation
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      readOnly
                      dateFormat={Constants.DATE_FORMAT}
                      selected={this.state.fromDate}
                    />
                  </span>
                  <br />
                  {(!this.state.validity.fromDate ||
                    !this.state.validity.dateRange) && (
                      <ErrorLabel
                        message={
                          !this.state.validity.dateRange
                            ? Messages.INVALID_DATE_RANGE
                            : Messages.INVALID_START_DATE
                        }
                      />
                    )}
                </div>

                <div className=" col-md-3">
                  <span className="datepicker-wrapper">
                    <label className="input-control-label required">To</label>
                    <Datepicker
                      onChange={this.onToDateChange}
                      id="toDate"
                      className="form-control"
                      dateFormat={Constants.DATE_FORMAT}
                      placeHolderText="To Date"
                      disabledKeyboardNavigation
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      readOnly
                      dropdownMode="select"
                      minDate={this.state.fromDate}
                      maxDate={
                        this.state.fromDate
                          ? this.state.fromDate
                            .clone()
                            .add(Constants.MAX_DATE_RANGE_DAYS, "days")
                          : Moment()
                      }
                      selected={this.state.toDate}
                    />
                  </span>
                  <br />
                  {(!this.state.validity.toDate ||
                    !this.state.validity.dateRange) && (
                      <ErrorLabel
                        message={
                          !this.state.validity.dateRange
                            ? Messages.INVALID_DATE_RANGE
                            : Messages.INVALID_END_DATE
                        }
                      />
                    )}
                </div>
              </div>
              {this.state.transactionGroupFiltersRequired.length ? (
                <div className="panel panel-default">
                  <div className="panel-body">
                    <h5 className="m-0 bold">Required parameters</h5>
                    {this.state.transactionGroupFiltersRequired.map(
                      (filterArray, index) => (
                        <div className="row mt-1" key={index}>
                          {filterArray.map(filter => {
                            return (
                              <div key={filter} className="col-md-3">
                                <label className="input-control-label">
                                  {Util.regularFormString(filter)}
                                </label>
                                <FloatInput
                                  value={this.state[filter]}
                                  onChange={this.onTextInputChange}
                                  id={filter}
                                  name={filter}
                                  placeholder={Util.regularFormString(filter)}
                                  showError={
                                    this.state.touchedForm &&
                                    this.state[filter] &&
                                    !this.state.filterValidity[filter]
                                  }
                                  errorMessage={` ${Messages.INVALID_IDENTIFIER
                                    } ${filter}`}
                                />
                              </div>
                            );
                          })}
                        </div>
                      )
                    )}
                  </div>
                </div>
              ) : null}

              {this.state.transactionGroupFiltersAdditional.length ? (
                <div className="panel panel-default">
                  <div className="panel-body">
                    <h5 className="m-0 bold">Additional parameters</h5>
                    {this.state.transactionGroupFiltersAdditional.map(
                      (filterArray, index) => (
                        <div className="row mt-1" key={index}>
                          {filterArray.map(filter => {
                            return (
                              <div key={filter} className="col-md-3">
                                <label className="input-control-label">
                                  {Util.regularFormString(filter)}
                                </label>
                                <FloatInput
                                  value={this.state[filter]}
                                  onChange={this.onTextInputChange}
                                  id={filter}
                                  name={filter}
                                  placeholder={Util.regularFormString(filter)}
                                  showError={
                                    this.state.touchedForm &&
                                    this.state[filter] &&
                                    !this.state.filterValidity[filter]
                                  }
                                  errorMessage={` ${Messages.INVALID_IDENTIFIER
                                    } ${filter}`}
                                />
                              </div>
                            );
                          })}
                        </div>
                      )
                    )}
                  </div>
                </div>
              ) : null}
            </div>
            <div className="col-md-2">
              <button
                disabled={
                  this.state.searchButtonDisabled || !this.isValidForm()
                }
                className="btn btn-primary btn-block mt-20"
                type="submit"
              >
                Search
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }

  isValidForm() {
    if (!this.state.touchedForm) return false;
    let isValid = true;
    for (let i in this.state.validity) {
      isValid = isValid && this.state.validity[i];
    }
    return isValid && this.state.validFilter;
  }

  returnValidityFilters() {
    let filterValiditiesRequired = {};
    let filterValiditiesAdditional = {};
    if (
      this.state.transactionGroupFiltersRequired &&
      this.state.transactionGroupFiltersRequired.length
    ) {
      this.state.transactionGroupFiltersRequired.forEach(filterArray =>
        filterArray.forEach(filter => {
          filterValiditiesRequired[filter] =
            this.state.filterValidity[filter] || false;
        })
      );
    }
    if (
      this.state.transactionGroupFiltersAdditional &&
      this.state.transactionGroupFiltersAdditional.length
    ) {
      this.state.transactionGroupFiltersAdditional.forEach(filterArray =>
        filterArray.forEach(filter => {
          filterValiditiesAdditional[filter] =
            this.state.filterValidity[filter] || false;
        })
      );
    }
    const validity = this.checkFilterValidity(
      filterValiditiesRequired,
      filterValiditiesAdditional
    );
    this.setState({
      validFilter: validity
    });
  }

  checkFilterValidity(required, additional) {
    let isRequiredValid = true;
    let isAdditionalValid = false;
    let hasRequired = false;

    if (Object.keys(required).length === 0) {
      isRequiredValid = true;
    } else {
      for (let i in required) {
        hasRequired = true;
        isRequiredValid = isRequiredValid && required[i];
      }
    }

    if (Object.keys(additional).length === 0) {
      isAdditionalValid = true;
    } else {
      for (let i in additional) {
        isAdditionalValid = isAdditionalValid || additional[i];
      }
    }

    if (hasRequired && isRequiredValid) {
      return true;
    }

    return isRequiredValid && isAdditionalValid;
  }

  setValidityAndReturn(fieldId, validity, isFilter) {
    let validityState = Object.assign(
      {},
      isFilter ? this.state.filterValidity : this.state.validity
    );
    validityState[fieldId] = validity;
    return validityState;
  }

  clearAdvancedInputs() {
    let validity = Object.assign({}, this.state.validity);
    let stateUpdate = {};
    let selectedChannel = this.state.selectedChannel;
    if (selectedChannel) {
      selectedChannel.additionalParameters &&
        selectedChannel.additionalParameters.forEach(filter => {
          validity[filter] = true;
          stateUpdate[filter] = "";
        });
      selectedChannel.requiredParameters &&
        selectedChannel.requiredParameters.forEach(filter => {
          validity[filter] = true;
          stateUpdate[filter] = "";
        });
    }
    stateUpdate.validity = validity;
    this.setState(stateUpdate);
  }

  validateInputField(field, value, allowEmpty) {
    let isValid = true;

    if (!value && allowEmpty) return isValid;

    switch (field) {
      case Constants.TXN_IDENTIFIER_PAN.name:
        isValid = Constants.REG_EXPR_VALID_PAN.test(value);
        break;
      case Constants.TXN_IDENTIFIER_PAYCODE.name:
        isValid = Constants.REG_EXPR_VALID_DIGITS.test(value);
        break;
      default:
        isValid = !!value;
    }

    return isValid;
  }
}

export default permissioned(NewClaimTxnFilter);



// WEBPACK FOOTER //
// ./src/components/disputeMgmt/newClaim/newClaimTxnFilter.js